import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import Keycloak from "keycloak-js";
import { AppRoutes } from "src/app/enums";
import { PRODUCT_BRAND } from "src/app/product";
import { hasHouseclawAccess } from "src/app/utils/houseclaw-access";

export const houseclawGuard: CanActivateFn = () => {
  const keycloak = inject(Keycloak);
  const router = inject(Router);

  if (hasHouseclawAccess(keycloak)) {
    return true;
  }

  // On HouseClaw there is no Talk BI home to fall back to, so explain instead of looping back here.
  const fallback = inject(PRODUCT_BRAND).product === "houseclaw" ? AppRoutes.accessRequired : AppRoutes.empty;
  return router.createUrlTree([fallback]);
};

export const accessRequiredGuard: CanActivateFn = () => {
  const keycloak = inject(Keycloak);
  const router = inject(Router);

  return !hasHouseclawAccess(keycloak) || router.createUrlTree([AppRoutes.realEstate]);
};
